module.exports = __webpack_public_path__ + "img/22-3.5f8f4893.png";